function getColorWithRank(color) {
    if(color) {
        return `rgba(250,62,62, ${parseInt(color)/100})`;
    }
    return 'transparent';
}


export {getColorWithRank};